<template>
    <div>
        <div class="companiesOrder">
            <div class="companyOrder" v-for="(startup, index) in startups">
                <div class="row">
                    <div class="col-md-5">
                        <div class="form-group">
                            <label :for="'startups[' + index + '][name]'">
                                <slot name="name-label"></slot>
                            </label>
                            <input type="text" :name="'startups[' + index + '][name]'" v-model="startup.name"  @keydown.enter.prevent>
                        </div>
                    </div>

                    <div class="col-md-5">
                        <div class="form-group">
                            <label :for="'startups[' + index + '][email]'">
                                <slot name="email-label"></slot>
                            </label>
                            <input type="text" :name="'startups[' + index + '][email]'" v-model="startup.email"  @keydown.enter.prevent>
                        </div>
                    </div>

                    <div class="col-md-2 companyOrder__actions">
                        <button type="button" class="btn-medium-grey companyOrder__delete" @click="deleteCompany(index)">
                            <slot name="delete-label"></slot>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <button type="button" class="btn-blue" @click="addCompany">
                <slot name="add-label"></slot>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            oldCompanies: {
                name: String,
                email: String,
                default: () => [
                    {
                        name: '',
                        email: ''
                    }
                ]
            }
        },
        data() {
            return {
                startups: this.oldCompanies
            }
        },
        methods: {
            addCompany() {
                this.startups.push({
                    name: '',
                    email: ''
                });
            },
            deleteCompany(index) {
                this.startups.splice(index, 1);
                if (this.startups.length === 0) {
                    this.addCompany();
                }
            }
        }
    }
</script>
